/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_07_DescInputs */

const en_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI governance controls, EU data security, and accessibility evidence are documented. Human review stays in your hands before every AI-assisted submission.`)
};

const de_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Governance-Kontrollen, EU-Datensicherheit und Nachweise zur Barrierefreiheit sind dokumentiert. Die menschliche Kontrolle liegt vor jeder KI-gestützten Einreichung bei dir.`)
};

const fr_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les contrôles de transparence, les preuves d’accessibilité et les limites actuelles sont documentés.`)
};

const es_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los controles de transparencia, las pruebas de accesibilidad y las limitaciones actuales están documentados.`)
};

const it_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I controlli di trasparenza, le evidenze di accessibilità e le limitazioni attuali sono documentati.`)
};

const nl_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparantiecontroles, toegankelijkheidsbewijs en actuele beperkingen zijn gedocumenteerd.`)
};

const pl_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mechanizmy przejrzystości, dowody dostępności i aktualne ograniczenia są udokumentowane.`)
};

const fi_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läpinäkyvyysominaisuudet, saavutettavuusnäyttö ja nykyiset rajoitukset on dokumentoitu.`)
};

const da_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemsigtighedskontroller, dokumentation for tilgængelighed og aktuelle begrænsninger er beskrevet.`)
};

const sv_landing_section_07_desc = /** @type {(inputs: Landing_Section_07_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparenskontroller, tillgänglighetsunderlag och aktuella begränsningar är dokumenterade.`)
};

/**
* | output |
* | --- |
* | "AI governance controls, EU data security, and accessibility evidence are documented. Human review stays in your hands before every AI-assisted submission." |
*
* @param {Landing_Section_07_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_07_desc = /** @type {((inputs?: Landing_Section_07_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_07_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_07_desc(inputs)
	if (locale === "fr") return fr_landing_section_07_desc(inputs)
	if (locale === "es") return es_landing_section_07_desc(inputs)
	if (locale === "it") return it_landing_section_07_desc(inputs)
	if (locale === "nl") return nl_landing_section_07_desc(inputs)
	if (locale === "pl") return pl_landing_section_07_desc(inputs)
	if (locale === "fi") return fi_landing_section_07_desc(inputs)
	if (locale === "da") return da_landing_section_07_desc(inputs)
	if (locale === "sv") return sv_landing_section_07_desc(inputs)
	return en_landing_section_07_desc(inputs)
});